import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { LoginResponse } from 'src/types'
import Settings from './Setting/Settings'
import './UploadCSVModal/UploadCSVModal'

import './UserSettings.sass'

const UserSettings = () => {

  const [visible, setVisible] = useState(false)
  const { username: name, role } = useSelector((s: {user: LoginResponse}) => s.user)

  return (
    <div className="user-settings">
      <button className="filled" onClick={() => setVisible(!visible)}>
        <span className="icon icon-user" />
        <span className="name">{name}</span>
      </button>
      <ul className={`bubble ${visible ? 'visible' : ''}`}>
        <Settings role={role} />
      </ul>
    </div>
  )
}

export default UserSettings
